import type { Agreements } from '../agreement';
import type { AgreementPrefixEnum, Asset } from '../asset';
import type { SearchParameters } from '../searchParameters';
import { isPaExhausted, isPaViewOnly } from './paAgreementState';

export enum DownloadOfferEnum {
  AGREEMENT = 'agreement',
  VIEW_ONLY = 'viewOnly',
  NONE = 'none',
}

export type DownloadOffer =
  | Readonly<{ kind: DownloadOfferEnum.AGREEMENT; prefix: AgreementPrefixEnum }>
  | Readonly<{ kind: DownloadOfferEnum.VIEW_ONLY }>
  | Readonly<{ kind: DownloadOfferEnum.NONE }>;

const NONE: DownloadOffer = { kind: DownloadOfferEnum.NONE };
const VIEW_ONLY: DownloadOffer = { kind: DownloadOfferEnum.VIEW_ONLY };

// What the visitor's agreements offer for an asset, before PA-preview mode:
// the overlay hides its button from a previewer, the fixed tile's footer
// doesn't, so each caller applies preview itself.
//
// A view-only premium-access search wins over an agreement the asset carries,
// so the overlay and the footer never contradict each other on one tile.
export const getDownloadOffer = (
  asset: Asset,
  agreements: Agreements,
  searchParameters: SearchParameters
): DownloadOffer => {
  if (asset.isAnalogArchive) return NONE;
  if (isPaViewOnly(agreements, searchParameters)) return VIEW_ONLY;

  const prefix = asset.agreementPrefix();
  return prefix && !isPaExhausted(agreements, searchParameters)
    ? { kind: DownloadOfferEnum.AGREEMENT, prefix }
    : NONE;
};
